import classNames from 'classnames';
import {
  Check,
  ListFilter,
} from 'lucide-react';
import {
  type MouseEvent,
  useRef,
  useState,
} from 'react';
import { PopupMenu } from './PopupMenu';

type Open = { top: number, right: number, focusFirst: boolean };

// the list's filters, behind an icon inside the search field; the icon shows
// in the accent while any filter is on
export const SearchFilter = (
  { showArchived, onShowArchived, showDeleted, onShowDeleted }: {
    showArchived: boolean,
    onShowArchived: (show: boolean) => void,
    showDeleted: boolean,
    onShowDeleted: (show: boolean) => void,
  },
) => {
  const [open, setOpen] = useState<Open | null>(null);
  const button = useRef<HTMLButtonElement>(null);

  const close = (refocus = false) => {
    setOpen(null);
    if (refocus) button.current?.focus();
  };

  // a click with no pointer behind it came from the keyboard
  const toggle = (e: MouseEvent) => {
    if (open || !button.current) return close();
    const r = button.current.getBoundingClientRect();
    setOpen({
      top: r.bottom + 4,
      right: window.innerWidth - r.right,
      focusFirst: e.detail === 0,
    });
  };

  return (
    <>
      <button
        ref={button}
        className={classNames('search-filter', {
          active: showArchived || showDeleted,
        })}
        title="Filters"
        aria-label="Filters"
        aria-haspopup="menu"
        aria-expanded={Boolean(open)}
        onClick={toggle}>
        <ListFilter aria-hidden="true" />
      </button>
      {open && (
        <PopupMenu
          at={{ top: open.top, right: open.right }}
          focusFirst={open.focusFirst}
          onClose={close}
          opener={button}>
          <button
            role="menuitemcheckbox"
            aria-checked={showArchived}
            onClick={() => {
              close();
              onShowArchived(!showArchived);
            }}>
            <span className="icon">
              {showArchived && <Check aria-hidden="true" />}
            </span>
            Show archived
          </button>
          <button
            role="menuitemcheckbox"
            aria-checked={showDeleted}
            onClick={() => {
              close();
              onShowDeleted(!showDeleted);
            }}>
            <span className="icon">
              {showDeleted && <Check aria-hidden="true" />}
            </span>
            Show deleted
          </button>
        </PopupMenu>
      )}
    </>
  );
};
